export default __webpack_public_path__ + "static/6.5 - 5-49177c601de6a861b402240ae50fc7ce.png";